import { apiUrl } from '../utils/api';

export interface ProjectContact {
  accountExec?: string;
  accountExecEmail?: string;
  technicalLead?: string;
  technicalLeadEmail?: string;
}

export interface SnapshotEntry {
  version: number;
  label: string;
  timestamp: string;
  workloadCount: number;
  factCount: number;
  riskCount: number;
  decisionCount: number;
  stakeholderCount: number;
  azureConsumptionMonthly?: number;
  w365LicensingMonthly?: number;
  grandTotalMonthly?: number;
  summary?: string;
}

export interface Project {
  id?: string;
  customerId: string;
  name: string;
  status: string;
  cafPhase: string;
  scope?: string;
  azureRegion?: string;
  hypervisor?: string;
  vpnType?: string;
  contacts?: ProjectContact;
  snapshots?: SnapshotEntry[];
  createdAt?: string;
  updatedAt?: string;
}

export interface ScaffoldResult {
  scaffolded: number;
  documents: { id: string; title: string; cafPhase: string; status: string }[];
}

export async function listProjects(customerId: string, token: string): Promise<Project[]> {
  const res = await fetch(apiUrl(`/api/projects?customerId=${encodeURIComponent(customerId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to list projects: ${res.status}`);
  return res.json();
}

export async function getProject(id: string, customerId: string, token: string): Promise<Project> {
  const res = await fetch(apiUrl(`/api/projects/${id}?customerId=${encodeURIComponent(customerId)}`), {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to get project: ${res.status}`);
  return res.json();
}

export async function createProject(project: Project, token: string): Promise<Project> {
  const res = await fetch(apiUrl('/api/projects'), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify(project),
  });
  if (!res.ok) throw new Error(`Failed to create project: ${res.status}`);
  return res.json();
}

export async function scaffoldDocuments(projectId: string, customerId: string, token: string): Promise<ScaffoldResult> {
  const res = await fetch(apiUrl(`/api/projects/${projectId}/scaffold?customerId=${encodeURIComponent(customerId)}`), {
    method: 'POST',
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!res.ok) throw new Error(`Failed to scaffold: ${res.status}`);
  return res.json();
}
